import { useEffect } from "react";
import { useLocation } from "react-router-dom";
let navegacionInterna = false;
function BlockBackButton({ redirecciones }) {
  const location = useLocation();

  useEffect(() => {
    const handlePopState = () => {
      if (navegacionInterna) {
        // Ignoramos este popstate porque viene de un clic interno
        navegacionInterna = false;
        return;
      }

      const destino = redirecciones[location.pathname];
      if (destino) {
        window.location.hash = `#${destino}`;
      } else {
        window.history.pushState(null, "", window.location.href);
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [location, redirecciones]);

  return null;
}


export default BlockBackButton;